import { render, staticRenderFns } from "./ItemsSupplierOrderCreate.vue?vue&type=template&id=5727c349&"
import script from "./ItemsSupplierOrderCreate.vue?vue&type=script&lang=js&"
export * from "./ItemsSupplierOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports